import Vue from 'vue'

function list (params = {}) {
  const path = '/admin/external-crms'
  return Vue.api.get(path, { params })
}

export default {
  list
}
